'use client';

import { useMessages } from 'next-intl';
import { useCallback } from 'react';
import {
  resolveErrorMessage,
  type ErrorMessageVars,
  type ErrorsCatalog,
} from '../utils/errorInterpolate';

/**
 * Tier 2 hook: pulls the `errors` catalog from the nearest
 * NextIntlClientProvider via useMessages() and delegates to resolveErrorMessage.
 *
 * Use this only on pages that already wrap their subtree with a scoped
 * NextIntlClientProvider that includes `errors` (cart, product, etc).
 *
 * For Tier 1 pages that pass the errors catalog as a prop (auth, contact,
 * account/*), call resolveErrorMessage(err, translations.errors) directly.
 */
export function useErrorMessage() {
  const messages = useMessages() as { errors?: ErrorsCatalog };
  const catalog = messages.errors ?? {};

  return useCallback(
    (error: unknown, vars?: ErrorMessageVars): string =>
      resolveErrorMessage(error, catalog, vars),
    [catalog],
  );
}
